import { gql } from "@apollo/client";

export const QUERY_AI_CITATIONS = gql`
    query AiCitationSearch(
        $bedrooms: [Int],
        $operation_type_id: Int,
        $locations: [LocationInput],
        $property_type_id: [Int],
        $location_slug: String,
        $location_title: String,
        $offer_type_slug: String,
        $category_slug: String,
        $bedroom_id: String,
        $location_level: Int,
        $url: String
    ) {
        aiCitationSearch(
            bedrooms: $bedrooms,
            operation_type_id: $operation_type_id,
            locations: $locations,
            property_type_id: $property_type_id,
            location_slug: $location_slug,
            location_title: $location_title,
            offer_type_slug: $offer_type_slug,
            category_slug: $category_slug,
            bedroom_id: $bedroom_id,
            location_level: $location_level,
            url: $url
        ) {
            html_description
            metadata {
                url 
                location_title
                uuid
                location_breadcrumb
                offer_type_title
                category_title
                bedroom_id
                title
                location_level
            }
        }
    }
`;
